module.exports = __webpack_public_path__ + "static/media/buildingConstruction5.ba95a406.jpg";